import "./Preview.css";
const PreviewBtn = ({ setSubmit, submit, isReadOnly = false }) => {
  return (
    <button
      type="button"
      className="invite-save-button"
      onClick={() => setSubmit(true)}
      disabled={isReadOnly || submit}
      title={isReadOnly ? "מערכת לדוגמא בלבד - לא ניתן לערוך" : undefined}
    >
      {submit ? (
        <span className="spinner-border spinner-border-sm" role="status" aria-label="שומר שינויים" />
      ) : (
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5 9.2 17 19 7" /></svg>
      )}
      <span>{submit ? "שומר..." : "שמירת שינויים"}</span>
    </button>
  );
};

export default PreviewBtn;
